// extracted by mini-css-extract-plugin
module.exports = {"style":"AppHeaderUser_style__3liL0"};